var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 40,
    viewBox: "0 0 184 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2354 40V0L40.8743 0V40H47.2354Z",
    fill: "#FEBA06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6089 40V0L27.2479 0L27.2479 40H33.6089Z",
    fill: "#FEBA06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9825 26.525V0L13.6215 0L13.6215 26.525H19.9825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36609 40L6.36609 0L0.00505924 0L0.00505924 40H6.36609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8568 40V0L54.4958 0V40H60.8568Z",
    fill: "#FEBA06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9277 17.095V0.38501H83.6786C85.5227 0.38501 87.0233 0.92501 88.1298 1.98501C89.2363 3.04501 89.7971 4.46501 89.7971 6.20501C89.7971 7.94501 89.2059 9.47501 88.0439 10.56C86.8768 11.65 85.2852 12.2 83.3198 12.2H79.4446V17.09H74.9277V17.095ZM79.4446 8.75501H82.7237C83.4664 8.75501 84.0979 8.53001 84.5931 8.08501C85.0983 7.63501 85.3509 7.04501 85.3509 6.33001C85.3509 5.61501 85.0933 5.08501 84.588 4.65001C84.0929 4.22501 83.4613 4.00501 82.7186 4.00501H79.4396V8.75001L79.4446 8.75501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.474 17.095L102.514 14.485H95.37L94.3848 17.095H89.5446L96.3553 0.38501H101.539L108.345 17.095H103.479H103.474ZM96.7342 10.805H101.18L98.9724 4.79001L96.7342 10.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.241 17.095L107.157 0.38501H112.205L116.55 11L120.865 0.38501H125.912L118.829 17.095H114.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.238 0.38501H127.721V17.095H132.238V0.38501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37 17.095L140.074 7.90001V17.095H135.557V0.38501H139.316L147.612 9.90001V0.38501H152.159V17.095H148.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.977 17.48C161.395 17.48 159.187 16.625 157.419 14.945C155.656 13.265 154.761 11.18 154.761 8.745C154.761 6.31 155.656 4.225 157.419 2.54C159.187 0.855005 161.385 0.00500488 163.952 0.00500488C165.953 0.00500488 167.736 0.450005 169.247 1.33C170.672 2.16 171.677 3.315 172.248 4.77L167.615 5.92C166.877 4.635 165.644 3.985 163.957 3.985C162.623 3.985 161.506 4.445 160.637 5.345C159.774 6.245 159.334 7.39 159.334 8.74C159.334 10.09 159.784 11.235 160.663 12.135C161.547 13.04 162.684 13.495 164.033 13.495C165.963 13.495 167.317 12.73 168.065 11.22L168.221 10.9H163.634V7.3H172.849C172.91 8.11001 172.935 8.59 172.935 8.76501C172.935 11.32 172.091 13.43 170.429 15.045C168.762 16.66 166.594 17.475 163.977 17.475V17.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7368 40V32.465L90.3074 32.365L86.513 40H83.5624L79.768 32.415L79.3436 32.515V40H74.9277V23.29H79.8185L85.0225 32.91L90.2569 23.29H95.1476V40H90.7368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.841 40L109.886 37.39H102.741L101.756 40H96.916L103.722 23.29H108.905L115.711 40H110.846H110.841ZM104.101 33.71H108.547L106.339 27.695L104.101 33.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.751 40L122.992 34.52H121.991V40H117.474V23.29H126.488C128.282 23.29 129.752 23.805 130.848 24.815C131.94 25.825 132.495 27.175 132.495 28.825C132.495 30.135 132.137 31.275 131.429 32.215C130.722 33.15 129.732 33.82 128.489 34.195L128.16 34.295L133.137 39.995H127.756L127.751 40ZM121.991 31.075H125.553C126.296 31.075 126.902 30.88 127.357 30.495C127.822 30.1 128.059 29.585 128.059 28.955C128.059 28.325 127.822 27.84 127.357 27.465C126.902 27.1 126.301 26.915 125.558 26.915H121.996V31.075H121.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.879 40L141.039 33.955H139.826V40H135.31V23.29H139.826V29.77H140.781L145.93 23.29H151.235L144.652 31.7L151.705 40H145.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.534 40V23.29H166.771V26.995H158.051V29.975H166.074V33.29H158.051V36.295H166.877V40H153.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.021 40V27.07H168.59V23.29H184V27.07H178.569V40H174.021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f411d2aeef95fffac3004735aaf49965.svg";
export { ForwardRef as ReactComponent };